export default __webpack_public_path__ + "static/escalator_w.fb44b96bd16b9b2fe4d1503b97e10e7b.svg";